/* eslint-disable */
export default {
  download: 'Scarica',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
